import { sendToGoogleSheetsReal as apiSendToGoogleSheets, testGoogleSheetsConnection as apiTestGoogleSheetsConnection } from './googleSheetsReal';

interface GoogleSheetsConfig {
  spreadsheetUrl: string;
  sheetName: string;
  syncMode: 'append' | 'replace' | 'update';
  includeMetadata: boolean;
  includeRawData: boolean;
  customColumns: Array<{key: string; label: string; enabled: boolean}>;
  autoCreateSheet: boolean;
  syncFrequency: 'manual' | 'onChange' | 'daily';
}

export async function sendToGoogleSheets(config: GoogleSheetsConfig, payload: any) {
  try {
    const result = await apiSendToGoogleSheets(config, payload);
    
    if (result.success) {
      console.log(`✅ Google Sheets sync successful: ${result.message}`);
      console.log(`📊 Rows added: ${result.rowsAdded}`);
    } else {
      console.error(`❌ Google Sheets sync failed: ${result.message}`);
    }
    
    return result;
  } catch (error: any) {
    console.error('Google Sheets sync error:', error);
    return {
      success: false,
      message: error.message || 'Failed to sync to Google Sheets',
      rowsAdded: 0
    };
  }
}

export async function testGoogleSheetsConnection(config: GoogleSheetsConfig) {
  try {
    const result = await apiTestGoogleSheetsConnection(config);
    
    if (result.success) {
      console.log(`✅ Google Sheets connection test successful: ${result.message}`);
    } else {
      console.error(`❌ Google Sheets connection test failed: ${result.message}`);
    }
    
    return result;
  } catch (error: any) {
    console.error('Google Sheets connection test error:', error);
    return {
      success: false,
      message: error.message || 'Failed to test Google Sheets connection'
    };
  }
}

// Legacy function for backward compatibility
export async function sendToGoogleSheetsWebhook(webAppUrl: string, payload: any) {
  const res = await fetch(webAppUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    mode: 'cors',
  });
  
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Sheets webhook ${res.status}: ${text || res.statusText}`);
  }
  
  return res.json().catch(() => ({}));
}
